const routes = [
    {
        path: "/esl/change-of-class/requests",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'changeofclassrequest_index'
        },
    },
    {
        path: "/esl/change-of-class/request-form",
        component: () => import("../pages/StudentForm.vue"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        },
    },
];

export default routes;
